import React from 'react'
import { useFieldArray } from 'react-hook-form'
import { Content, Label } from './styles'
import { Row } from '../../../../../components/commons'
import Input from '../../../../../components/Input'
import { ButtonIcon } from '../../../../../components/Table/Pagination/styles'
import { api } from '../../../../../services/api'
import useToast from '../../../../../hooks/useToast'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import { useTheme } from 'styled-components'

export interface MetaDataValuesProps {
  control: any
  label?: string
  error?: any
  setIsIndexFound: (index?: string) => void
  getValues: any
  setValue: any
  isIndexFound?: any
  documentTypeId: string
  disabled?: boolean
  name: string
}

const MetaDataValues: React.FunctionComponent<MetaDataValuesProps> = ({
  control,
  setValue,
  getValues,
  label,
  setIsIndexFound,
  isIndexFound,
  documentTypeId,
  error,
  name,
}) => {
  const [loading, setloading] = React.useState(false)
  const { fields, update, replace } = useFieldArray({
    control,
    name: name,
  })
  const toast = useToast()
  const theme: any = useTheme()

  const handleSearchByIndex = async (name: string) => {
    try {
      setloading(true)

      const values = getValues()

      const field = values.metadata.find((meta: any) => meta.name === name)

      if (!field?.value || field?.value === '') return

      const { data: response } = await api.get(`/documents/searchIndex`, {
        params: {
          documentTypeId,
          name,
          value: field?.value,
        },
      })

      if (response.length > 0) {
        toast.successToast('Index do documento encontrado com sucesso!')

        let documentTypeWithData = response[0]

        if (documentTypeWithData._id) setIsIndexFound(documentTypeWithData._id)

        documentTypeWithData.metadata.map((meta: any, index: number) => {
          setValue(`metadata.${index}.value`, meta.value)
        })
      } else {
        toast.errorToast('Index do documento não encotrado!')
      }
    } catch (error) {
      console.log(error)
    } finally {
      setloading(false)
    }
  }

  return (
    <Content>
      {label && (
        <Row
          align='center'
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
          gap={10}
        >
          <Label style={{ fontSize: 16, marginBottom: 0 }}>{label}</Label>
          {isIndexFound && (
            <ButtonIcon onClick={() => setIsIndexFound()}>Remover Index vinculado!</ButtonIcon>
          )}
        </Row>
      )}

      {fields.map((cp: any, index: number) => {
        let errorValue = error && typeof error[index] !== 'undefined' ? error[index].name : ''

        return (
          <>
            <Input
              key={cp._id}
              control={control}
              error={errorValue}
              disabled={isIndexFound}
              button={
                <>
                  <ButtonIcon
                    onClick={() => handleSearchByIndex(cp.name)}
                    style={{ minHeight: 20, minWidth: 20, width: 20, height: 20, margin: 'auto' }}
                    type='button'
                  >
                    <FaMagnifyingGlass size={20} color={theme.colors.primary} />
                  </ButtonIcon>
                </>
              }
              label={`${cp.name}`}
              name={`${name}.${index}.value`}
              type='text'
            />
          </>
        )
      })}
    </Content>
  )
}

export default MetaDataValues
